import Vue from "vue";
import get from "lodash/get";
import moment from "moment-timezone";

// const fullIconMap = {
//   clear: "clear",
//   clear_day: "clear_day",
//   clear_night: "clear_night",
//   cloudy: "cloudy",
//   dust: "dust",
//   dusty: "dust",
//   fog: "fog",
//   foggy: "fog",
//   frost: "frost",
//   hail: "hail",
//   haze: "hazy",
//   hazey: "hazy",
//   hazy: "hazy",
//   heavy_shower: "heavy_showers",
//   heavy_showers: "heavy_showers",
//   light_rain: "light_rain",
//   light_shower: "light_showers",
//   light_showers: "light_showers",
//   lightning: "lightning",
//   lightning_rainy: "lightning",
//   mostly_sunny: "mostly_sunny",
//   partly_cloudy: "partly_cloudy",
//   partlycloudy: "partly_cloudy",
//   pouring: "heavy_showers",
//   rain: "rain",
//   rainy: "rain",
//   shower: "showers",
//   showers: "showers",
//   sleet: "sleet",
//   snow: "snow",
//   snowy: "snow",
//   snowy_rainy: "snow_rain",
//   snowyrainy: "snow_rain",
//   storm: "storm",
//   stormy: "storm",
//   sunny: "sunny",
//   thunderstorm: "lightning",
//   tropical_cyclone: "cyclone",
//   tropicalcyclone: "cyclone",
//   wind: "windy",
//   windy: "windy",
//   windy_variant: "windy_variant",
// };

// Simplified icon map
const weatherMap = {
  clear: "sunny",
  clear_day: "sunny",
  clear_night: "sunny",
  cloudy: "cloudy",
  dust: "windy",
  dusty: "windy",
  fog: "fog",
  foggy: "fog",
  frost: "frost",
  hail: "hail",
  haze: "hazy",
  hazey: "hazy",
  hazy: "hazy",
  heavy_shower: "showers",
  heavy_showers: "showers",
  light_rain: "showers",
  light_shower: "showers",
  light_showers: "showers",
  lightning: "lightning",
  lightning_rainy: "lightning",
  mostly_sunny: "mostly_sunny",
  partly_cloudy: "partly_cloudy",
  partlycloudy: "partly_cloudy",
  pouring: "showers",
  rain: "showers",
  rainy: "showers",
  shower: "showers",
  showers: "showers",
  sleet: "snow",
  snow: "snow",
  snowy: "snow",
  snowy_rainy: "showers",
  snowyrainy: "showers",
  storm: "showers",
  stormy: "showers",
  sunny: "sunny",
  thunderstorm: "lightning",
  wind: "windy",
  windy: "windy",
  windy_variant: "windy",
};

const iconMap = {
  cloudy: "clouds",
  fog: "fog",
  frost: "icicles",
  hail: "cloud-hail",
  hazy: "sun-haze",
  lightning: "bolt",
  mostly_sunny: "sun-cloud",
  partly_cloudy: "cloud-sun",
  showers: "cloud-showers",
  snow: "snowflake",
  sunny: "sun",
  windy: "wind",
};

const state = {
  data: {},
};

/* eslint-disable no-shadow, no-param-reassign, arrow-body-style */
const actions = {
  fetch: async ({ commit }, postcode) => {
    const location = await Vue.http.get(
      `https://api.weather.bom.gov.au/v1/locations?search=${postcode}`
    );

    const geohash = get(location, "body.data[0].geohash");

    if (geohash) {
      const forecast = await Vue.http.get(
        `https://api.weather.bom.gov.au/v1/locations/${geohash}/forecasts/daily`
      );

      if (forecast && forecast.body.data && forecast.body.data && forecast.body.data.length === 7) {
        // Parse weather forecasts for the next 7 days
        const results = {};
        forecast.body.data.forEach((daily) => {
          let momentDate = moment(daily.date).tz("Australia/Melbourne");
          let date = momentDate.format("YYYY-MM-DD");
          let weekday = momentDate.format("ddd");
          let relativeDay = null;
          if (moment().format("YYYY-MM-DD") === date) {
            relativeDay = "(Today)";
          } else if (moment().add(1, "day").format("YYYY-MM-DD") === date) {
            relativeDay = "(Tomorrow)";
          } else if (moment().add(-1, "day").format("YYYY-MM-DD") === date) {
            relativeDay = "(Yesterday)";
          }

          let icon = null;
          try {
            icon = iconMap[weatherMap[daily.icon_descriptor]];
            // eslint-disable-next-line no-empty
          } catch (e) {}

          let shortText = daily.short_text;
          if (shortText[shortText.length - 1] === ".") {
            shortText = shortText.slice(0, -1);
          }

          results[date] = {
            date: date,
            weekday: weekday,
            relativeDay: relativeDay,
            temp_min: daily.temp_min,
            temp_max: daily.temp_max,
            icon_descriptor: daily.icon_descriptor,
            short_text: shortText,
            icon: icon,
          };
        });

        commit("setData", {
          postcode,
          data: results,
        });
      }
    }
  },

  getData: async ({ dispatch, state }, postcode) => {
    const now = new Date();

    if (
      !state.data[postcode] ||
      !state.data[postcode].expiry ||
      now.getTime() > state.data[postcode].expiry
    ) {
      await dispatch("fetch", postcode);
    }

    return get(state.data[postcode], "value");
  },
};

const mutations = {
  setData(state, payload, ttl) {
    if (ttl === undefined) {
      ttl = 60 * 60 * 1000 * 4; // 4 hour default
    }

    const now = new Date();

    state.data[payload.postcode] = {
      value: payload.data,
      expiry: now.getTime() + ttl,
    };
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
